export default __webpack_public_path__ + "static/media/information--traffic-merges-left--g1.3bc6a9de.png";